import { MenuItem } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const DropdownItem = ({ children, selected,padding, style, ...props }) => {
  return (
    <MenuItem
      {...props}
      sx={{
        padding: padding,
        color: selected ? "primary" : "primary",
        //color: "#000000",
        backgroundColor: selected ? "rgba(217, 217, 217, 0.35)" : "none",
        ...style
      }}
    >
      {children}
    </MenuItem>
  );
};

DropdownItem.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
};

DropdownItem.defaultProps = {};

export default DropdownItem;
